import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'categoryOptionLabel',
  standalone: true,
})
export class CategoryOptionLabelPipe implements PipeTransform {
  transform(category: any): string {
    if (!category) {
      return '';
    }
    const title = String(
      category['display_title'] || category['title'] || category['name'] || ''
    ).trim();
    const description = String(category['category_parent_description'] || '').trim();
    if (title && description && !title.includes(`(${description})`)) {
      return `${title} (${description})`;
    }
    return title;
  }
}
